import { render, staticRenderFns } from "./ExchangeGift.vue?vue&type=template&id=3aa16e4a&scoped=true&"
import script from "./ExchangeGift.vue?vue&type=script&lang=js&"
export * from "./ExchangeGift.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeGift.vue?vue&type=style&index=0&id=3aa16e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa16e4a",
  null
  
)

export default component.exports